import { OptionType } from '@evinced-private/ui-common';

import { createSortedOptions } from 'src/apps/mfa/helpers/QueryHelpers';

import { MfaOwnerOptionsQuery } from '../MfaOwnerOptions.generated';

export const transformMfaOwnerOptionsResults = (rawResults: MfaOwnerOptionsQuery): OptionType[] => {
	const userNames = rawResults.mfa_session_runs?.[0]?.user_name_group_uniq_array || [];
	const userNamesSet = new Set(userNames.filter((name) => name?.trim()));
	return createSortedOptions(userNamesSet);
};
